export default {
  Title: 'Stores | Store | Stores',

  List: {
    Title: 'See our stores'
  },

  SelectStoreDialog: {
    Title   : 'Our Stores',
    Subtitle: 'Select store'
  },

  Status: {
    Opened        : 'Open',
    Closed        : 'Closed',
    ClosedNoOrders: 'The store is closed and does not accept orders!',
    NoDelivery    : 'The store does not accept delivery orders!',
    NoCollection  : 'The store does not accept collection orders!'
  },

  OrderTime: {
    Suffix  : '@:Store.OrderTime.SuffixSM',
    SuffixXL: '@:Store.OrderTime.SuffixLG',
    SuffixLG: 'mins.',
    SuffixMD: '@:Store.OrderTime.SuffixSM',
    SuffixSM: 'mins.',
    SuffixXS: '\''
  },

  Notify: {
    Allergens: {
      Title: 'Allergens Information',
      Body : 'For each product (packaged food or meal), information regarding ingredients and allergens is provided on the Platform by the partner Stores and, where available, is displayed on the product page prior to the completion of the order. If you have a severe allergy or intolerance, please review the information provided and contact the relevant Store or Restaurant before placing your order. The allergen list is available upon request. For more detailed information regarding food allergens, click {0}.'
    }
  }
}
